/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_TitleInputs */

const es_tyc_liability_title = /** @type {(inputs: Tyc_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Descargo de Responsabilidad`)
};

const en_tyc_liability_title = /** @type {(inputs: Tyc_Liability_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6. Disclaimer of Liability`)
};

/**
* | output |
* | --- |
* | "6. Disclaimer of Liability" |
*
* @param {Tyc_Liability_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_title = /** @type {((inputs?: Tyc_Liability_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_title(inputs)
	return en_tyc_liability_title(inputs)
});
export { tyc_liability_title as "tyc.liability.title" }